/**
 * Created by mac on 10/9/20
 */

const AdminDataView = cc.Node.extend({
    ctor: function (availableWidth) {
        this._super();

        this.onReady = function () {};

        const styles = cleverapps.styles.AdminDataView;

        this.availableWidth = availableWidth - styles.padding.x * 2;

        const dataSource = cleverapps.administrator.adminDetails.statistics;

        this.reshape(dataSource.ready ? dataSource.getData() : []);

        if (!dataSource.ready) {
            dataSource.whenReady(this.createListener((data) => {
                this.reshape(data);
                this.onReady();
            }), this);
        }

        dataSource.on("reset", this.removeAllChildren.bind(this), this);
    },

    reshape: function (data) {
        this.removeAllChildren();

        const content = this.createData(data);
        this.setContentSize2(content.width * content.scaleX, content.height * content.scaleY);
        this.addChild(content);
        content.setAlignment(this.width / 2, this.height / 2);
    },

    createData: function (data) {
        const styles = cleverapps.styles.AdminDataView;

        const versions = data.map(function (versionData) {
            const versionNo = cleverapps.UI.generateOnlyText(`version_${versionData.version || 0}`, cleverapps.styles.FONTS.ADMIN_DATA_TEXT);
            versionNo.setAnchorPoint(0, 0.5);
            versionData = cleverapps.clone(versionData);
            delete versionData.version;

            const versionLayout = this.createVersionData(versionData);

            const layout = new cleverapps.Layout([versionNo, versionLayout], {
                direction: cleverapps.UI.VERTICAL,
                margin: styles.rowsMargin
            });

            const bg = cleverapps.UI.createScale9Sprite(bundles.admin.frames.lvl_bg);
            bg.setContentSize(layout.width + 12, layout.height + 12);
            layout.setAlignment(bg.width / 2, bg.height / 2);
            bg.addChild(layout);

            return bg;
        }, this);

        let versionScroll;

        if (versions.length) {
            const versionLayout = new cleverapps.Layout(versions, {
                direction: cleverapps.UI.HORIZONTAL,
                margin: styles.colsMargin
            });
            versionScroll = this.createScroll(versionLayout);
        }

        const annotation = new AdminLevelAnnotation(this.availableWidth);
        const mapTilesChooser = this.createMapTilesChooser();
        const mapUnitsChooser = this.createMapUnitsChooser();

        const items = [mapTilesChooser, mapUnitsChooser, versionScroll, annotation].filter((item, index, array) => {
            if (item) {
                item.setAnchorPoint(0, 0.5);
                item.setLocalZOrder(array.length - index);
                return true;
            }
            return false;
        });

        return new cleverapps.Layout(items, {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });
    },

    createDropDown: function (title, items, value, callback) {
        const styles = cleverapps.styles.AdminDataView;

        const label = cleverapps.UI.generateOnlyText(title, cleverapps.styles.FONTS.ADMIN_DATA_TEXT);

        const dropdown = new DropDown({
            availableItems: items,
            value,
            size: cc.size(styles.dropdown.width, label.height),
            font: cleverapps.styles.FONTS.ADMIN_DATA_TEXT
        });

        dropdown.setDelegate({
            editBoxEditingDidEnd: function (dropdown) {
                callback(dropdown.value);
            }
        });

        const layout = new cleverapps.Layout([label, dropdown], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.dropdown.margin
        });

        cleverapps.UI.fitToBox(layout, {
            width: this.availableWidth
        });

        return layout;
    },

    createMapTilesChooser: function () {
        if (typeof EditorMap2d === "undefined") {
            return;
        }

        const availableTiles = Map2d.AVAILABLE_TILES.map((tilesTexture) => tilesTexture.replace("tiles_", ""));
        availableTiles.sort((a, b) => a.localeCompare(b));

        const adminLevel = cleverapps.administrator.adminLevels.getActive();

        return this.createDropDown("Map tiles:", availableTiles, adminLevel.tiles, (value) => {
            LevelManager.getInstance().processLevelContent((content) => {
                content.tiles = value;
            });
        });
    },

    createMapUnitsChooser: function () {
        if (typeof EditorMap2d === "undefined") {
            return;
        }

        const availableUnits = Map2d.AVAILABLE_UNITS.map((tilesTexture) => tilesTexture.replace("units_", ""));
        availableUnits.sort((a, b) => Boolean(b === "main") - Boolean(a === "main") || a.localeCompare(b));

        const adminLevel = cleverapps.administrator.adminLevels.getActive();

        return this.createDropDown("Map units:", availableUnits, adminLevel.units, (value) => {
            LevelManager.getInstance().processLevelContent((content) => {
                content.units = value;
            });
        });
    },

    createScroll: function (content) {
        const styles = cleverapps.styles.AdminDataView;

        const scroll = new cleverapps.UI.ScrollView(content, {
            childrenVisibility: false
        });

        scroll.setContentSize2(Math.min(this.availableWidth, content.width), content.height + styles.scroll.padding.y * 2);
        scroll.scrollToPercent(0);
        return scroll;
    },

    createVersionData: function (data) {
        const styles = cleverapps.styles.AdminDataView;

        const items = Object.keys(data).map((key) => {
            const keyText = cleverapps.UI.generateOnlyText(`${key}: `, cleverapps.styles.FONTS.ADMIN_DATA_TEXT);
            keyText.setDimensions(styles.keyWidth, 0);

            let value = data[key];
            const url = value && value.url;

            if (value && value.text) {
                value = value.text;
            }

            const valueText = cleverapps.UI.generateOnlyText(`${value}`, cleverapps.styles.FONTS.ADMIN_DATA_TEXT);
            valueText.setDimensions(styles.valueWidth, 0);

            if (url) {
                cleverapps.UI.onClick(valueText, () => {
                    connector.platform.openUrl(url);
                });
            }

            const item = new cleverapps.Layout([keyText, valueText], {
                direction: cleverapps.UI.HORIZONTAL
            });
            item.setAnchorPoint(0, 0.5);
            return item;
        });

        const versionLayout = new cleverapps.Layout(items, {
            direction: cleverapps.UI.VERTICAL,
            reversed: true,
            margin: styles.rowsMargin
        });
        versionLayout.setAnchorPoint(0, 0.5);

        return versionLayout;
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    ADMIN_DATA_TEXT: {
        name: "formal",
        size: 17,
        color: cleverapps.styles.COLORS.BLACK
    },

    ADMIN_RED_TEXT: {
        name: "formal",
        size: 17,
        color: cleverapps.styles.COLORS.COLOR_RED
    }
});

cleverapps.styles.AdminDataView = {
    rowsMargin: 2,
    colsMargin: 20,
    keyWidth: 100,
    valueWidth: 160,

    margin: 10,

    annotation: {
        x: { align: "right" },
        y: { align: "center" }
    },

    dropdown: {
        width: 180,
        margin: 10
    },

    padding: {
        x: 20
    },

    scroll: {
        padding: {
            y: 0
        }
    }
};